import React from 'react';
import '../styles/Modules.css';

const Modules = () => {
    return (
        <section id='modules'>
            <div className="modules__heading">
                <h5>Academic Modules</h5>
                <h2>My Modules</h2>
            </div>
            <div className="modules__container">
                <article className='module'>
                    <h3>6BUIS018W.2 Information Driven Entrepreneurship and Enterprise</h3>
                </article>
                <article className='module'>
                    <h3>6COSC019W.2 Cyber Security</h3>
                </article>
                <article className='module'>
                    <h3>6COSC020W.1 Applied AI</h3>
                </article>
                <article className='module'>
                    <h3>6COSC023W.Y Computer Science Final Project</h3>
                </article>
                <article className='module'>
                    <h3>6DATA005W.1 Operational Research and Optimisation</h3>
                </article>
                <article className='module'>
                    <h3>5COSC019W.1 Object Oriented Programming</h3>
                </article>
                <article className='module'>
                    <h3>5COSC020W.1 Database Systems</h3>
                </article>
                <article className='module'>
                    <h3>5COSC021W.2 Software Development Group Project</h3>
                </article>
                <article className='module'>
                    <h3>5COSC022W.2 Client-Server Architectures</h3>
                </article>
                <article className='module'>
                    <h3>5DATA002W.2 Machine Learning and Data Mining</h3>
                </article>
                <article className='module'>
                    <h3>5ELEN018W.1 Robotic Principles</h3>
                </article>
                <article className='module'>
                    <h3>4COSC001W.1 Software Development I</h3>
                </article>
                <article className='module'>
                    <h3>4COSC002W.1 Mathematics for Computing</h3>
                </article>
                <article className='module'>
                    <h3>4COSC003W.2 Trends in Computer Science</h3>
                </article>
                <article className='module'>
                    <h3>4COSC004W.1 Computer Systems Fundamentals</h3>
                </article>
                <article className='module'>
                    <h3>4COSC005W.2 Software Development II</h3>
                </article>
                <article className='module'>
                    <h3>4COSC011W.2 Web Design and Development</h3>
                </article>
            </div>
        </section>
    );
};

export default Modules;
